import { useState } from "react";

import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";
import { groupAndSortPaginatedItems } from "utils/paginatedItems";

export const useSnoozedItemsHistory = (appointment_id: number) => {
  const [page, setPage] = useState(1);
  const canListAppointmentHistory = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.AppointmentHistory);

  const { data, isFetching, refetch } = useTypedQuery({
    queryKey: AppointmentDetailsKeys.snoozedItemsHistory(appointment_id, page),
    queryFn: async ({ baseUrl, endpoint, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data,
    select: groupAndSortPaginatedItems,
    enabled: canListAppointmentHistory
  });

  return {
    setPage,
    paginatedSnoozedItemsHistory: data,
    loading: isFetching,
    refetchSnoozedItemsHistory: refetch
  };
};
